var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.fr_FR}},[_c('div',{attrs:{"id":"app"}},[(_vm.mode === 'development')?_c('span',{staticStyle:{"color":"red","float":"left","position":"fixed"}},[_vm._v(" Mode "+_vm._s(_vm.mode)+" ")]):_vm._e(),_c('router-view',{attrs:{"name":"background"}}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }